<div class="progress-container" [class.compact]="compact">
  <div class="progress-fill" [style.width.%]="progress">
    <div class="progress-label">
      <span *ngIf="!compact">{{ progress }}%</span>
    </div>
  </div>
</div>
